import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class SchwabSsoFormModule {
}
SchwabSsoFormModule.ɵfac = function SchwabSsoFormModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SchwabSsoFormModule)(); };
SchwabSsoFormModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SchwabSsoFormModule });
SchwabSsoFormModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
